let getCustomizationStyle = (customStyles) => {
    if (!customStyles) {
        customStyles = {
            charlyHomeColor: '#00467f',
            charlyMtgColColor: '#fc604d',
            charlyNotisColor: '#bfbfbf',
            charlyFavsColor: '#fdc32e',
            charlyToolsColor: '#3495d1',
            charlyFontColor: '#fff',
            primaryColor: '#00467f',
            secondaryColor: '#fff',
            fontFamily: 'Quicksand'
        };
    }
    let charlyHomeColor = customStyles.charlyHomeColor;
    let charlyMtgColColor = customStyles.charlyMtgColColor;
    let charlyNotisColor = customStyles.charlyNotisColor;
    let charlyFavsColor = customStyles.charlyFavsColor;
    let charlyToolsColor = customStyles.charlyToolsColor;
    let charlyFontColor = customStyles.charlyFontColor;
    let primaryColor = customStyles.primaryColor;
    let secondaryColor = customStyles.secondaryColor;
    let fontFamily = customStyles.fontFamily;
    let logoStickToRight = customStyles.charlyLogoStickRight ? customStyles.charlyLogoStickRight : 'false';

    return (
        `
        body,
        html,
        input {
            font-family: ${fontFamily} !important;
        }
        
        .pdc-charly-home-background {
            background-color: ${charlyHomeColor};
        }
        
        .pdc-charly-mtgcol-background {
            background-color: ${charlyMtgColColor};
        }
        
        .pdc-charly-notis-background {
            background-color: ${charlyNotisColor};
        }
        
        .pdc-charly-favs-background {
            background-color:${charlyFavsColor};
        }
        
        .pdc-charly-tools-background {
            background-color: ${charlyToolsColor};
        }
        
        .pdc-charly-font-color {
            color: ${charlyFontColor};
        }
        
        .pdc-customization-primary-color {
            color: ${primaryColor};
        }
        
        .pdc-customization-primary-backgroundcolor {
            background-color: ${primaryColor};
        }
        
        .pdc-customization-secondary-color {
            color: ${secondaryColor};
        }
        
        .pdc-customization-secondary-backgroundcolor {
            background-color:${secondaryColor};
        }

        ${logoStickToRight === 'true' ?
            `.Home-logo-stick {
                right: 0px!important;
            }`
            :
            ''
        }
        `
    );
};

export default getCustomizationStyle;